// latest: zhangmyh 2017-4-1 4:36 PM
// 评估单指标参照
/* global $ u __ */
import Collection from 'common/vo/collection'
import 'collection/evalIndicator/evalIndicatorClass'
import 'collection/evalIndicator/evalIndicator'
import { Get } from 'common'

let _config
function init (refer) {
  // 树形控件加载有误,所以需要每次都重新加载
  let collection = Collection.create('evalapply.indicatorlist')
  let tree = Collection.create('evalapply.idrClassList')
  // let enterpriseId = refer.options.enterpriseId || window.global.user.enterpriseId
  tree.load()
  // let selectedNode = {}
  let selectedData = []
  let selectFlag = false
  let vm = {
    treemodel: tree.datatable,
    treeOption: {
      callback: {
        beforeClick: async function (id, obj) {
          if (!obj.flag) {
            var res = await Get('/cpu-supplymgr/supplyMgrBaseDoc/indicatorClass/getClassByParentId', {
              id: obj.id
            })
            tree.datatable.addSimpleData(res.data.result)
            obj.flag = true
          }
          // selectedNode = obj
          collection.datatable.removeAllRows()
          collection.load({
            supindicatorclassId: obj.id,
            pageIndex: 0,
            pageSize: 10
          })
        }
      }
    },
    gridconfig: {
      id: 'gridindicator',
      data: collection,
      type: 'grid',
      multiSelect: _config.multiSelect,
      editable: false,
      pagination: true,
      fields: [
        {
          'field': 'code',
          'dataType': 'String',
          'title': __('code'),
          'width': '33%'
        }, {
          'field': 'name',
          'dataType': 'String',
          'title': __('name'),
          'width': '33%'
        }, {
          'field': 'supindicatorclassName',
          'dataType': 'String',
          'title': '指标类别'
        }
      ]
    }
  }

  let app = u.createApp()
  app.init(vm, $('#eval_indicator_refer')[0])

  refer.registerSubmitFunc(() => {
    return selectedData
  })

  collection.on('data', function (result) {
    if (_config.multiSelect && !_config.repeatable && refer.options.defaultData) {
      // 初始化默认值
      if (selectedData.length <= 0) {
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          selectedData = defaultData
        }
      }
      let defaultData = refer.options.defaultData()
      if (defaultData instanceof Array) {
        let SelectIndex = []
        result.data.result.forEach(function (listItem, i) {
          defaultData.forEach(function (item) {
            if (item.id === listItem.id) {
              SelectIndex.push(i)
            }
          })
        })
        collection.datatable.setRowsSelect(SelectIndex)
      }
    }
    selectFlag = true
  })

  collection.datatable.on('unSelect', function (obj) {
    let selectData = collection.datatable.getRowByRowId(obj.rowIds[0])
    let index = -1
    selectedData.forEach(function (item, i) {
      if (item.id === selectData.getValue('id')) {
        index = i
      }
    })
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })

  collection.datatable.on('select', function (obj) {
    if (!_config.multiSelect) {
      let selectData = collection.datatable.getCurrentRow().data
      selectedData = {
        id: selectData.id.value,
        name: selectData.name.value,
        code: selectData.code.value,
        classId: selectData.supindicatorclassId.value,
        className: selectData.supindicatorclassName.value,
        desc: selectData.indicatorDesc.value,
        // maxScore: selectData.indicatorMaxScore.value,
        scoreStd: selectData.scoreStandard.value
      }
      refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectFlag) {
      let selectData = collection.datatable.getRowByRowId(obj.rowIds[obj.rowIds.length - 1]).data
      selectedData.push({
        id: selectData.id.value,
        name: selectData.name.value,
        code: selectData.code.value,
        classId: selectData.supindicatorclassId.value,
        className: selectData.supindicatorclassName.value,
        desc: selectData.indicatorDesc.value,
        // maxScore: selectData.indicatorMaxScore.value,
        scoreStd: selectData.scoreStandard.value
      })
    }
  })

  // tree.datatable.on('select', function (obj) {})
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    repeatable: false,
    multiSelect: false
  }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/evalIndicator/index.js